module.exports = __webpack_public_path__ + "static/media/-_Company profile.b65cef46.png";